module.exports = __webpack_public_path__ + "static/img/300.52c48e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/201206/300.jpg
// module id = FUsX
// module chunks = 0